export const CATEGORIES_TRANSLATION = {
    weapons: 'Оружие',
    protection: 'Средства защиты',
    knifes: 'Ножи',
    ammunition: 'Боеприпасы',
    clothes: 'Одежда и обувь',
    accessories: 'Аксессуары',
    gunsights: 'Оптика',
    knives: 'Ножи',
}

export const SUB_CATEGORIES_TRANSLATION = {
    // Weapons
    pistols: 'Пистолеты',
    rifles: 'Нарезное оружие',
    shotguns: 'Гладкоствольное оружие',
    traumatic: 'Травматическое оружие',
    pneumatic: 'Пневматическое оружие',
    
    // Ammunition
    for_shotguns: 'Патроны для гладкоствольного оружия',
    for_rifles: 'Патроны для нарезного оружия',
    for_pneumatic: 'Пульки для пневматического оружия',
    for_traumatic: 'Патроны для травматичесеого оружия',

    // Accessories
    gun_care: 'Уход за оружием',
    belts: 'Ремни',
    gun_cases: 'Чехлы',
    bipods: 'Сошки',
    special_tools: 'Инструменты',
    traps: 'Капканы',
    stuffed_animals: 'Чучела',
    headphones_glasses: 'Наушники и очки',
    rest_accessories: 'Остальные аксессуары',

    // Protection
    pepper_sprays: 'Перцовые балончики',
    stun_guns: 'Электрошокеры',
    rest_protection: 'Остальные средства защиты',

    // Gunsights
    optical_sights: 'Оптические прицелы',
    collimator_sights: 'Коллиматорные прицелы',
    thermal_sights: 'Тепловизионные прицелы',
    night_vision_devices: 'Приборы ночного видения',
    rangefinders: 'Дальномеры',
    binoculars: 'Бинокли',
    rest_gunsights: 'Остальное',
}
